import { render, staticRenderFns } from "./GroupDetails.vue?vue&type=template&id=27504056&scoped=true&"
import script from "./GroupDetails.vue?vue&type=script&lang=js&"
export * from "./GroupDetails.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetails.vue?vue&type=style&index=0&id=27504056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27504056",
  null
  
)

export default component.exports